module.exports = __webpack_public_path__ + "img/encointer-notee.bf81ede7.svg";